import React from 'react';
import { Typography } from 'antd';
import { HourGlassStatusIcon } from 'assets';
import { requestform } from 'messages';

interface RequestStatusBarProps {
  status?: string;
}

const getStatusInfo = (status: string) => {
  const statusMap: Record<string, { name: string; color: string }> = {
    pending_reception: { name: 'Chờ tiếp nhận', color: '#FF9500' },
    in_progress: { name: 'Đang xử lý', color: '#1564E8' },
    collaboration: { name: 'Phối hợp xử lý', color: '#AF52DE' },
    completed: { name: 'Đã xử lý', color: '#02D8A0' },
    obstacle: { name: 'Trở ngại', color: '#D1131D' },

    CHOTIEPNHAN: { name: 'Chờ tiếp nhận', color: '#FF9500' },
    DANGXULY: { name: 'Đang xử lý', color: '#1564E8' },
    HOANTAT: { name: 'Đã xử lý', color: '#02D8A0' },

    complaint: { name: 'Chờ xác nhận', color: '#02D8A0' },
    electrical_safety: { name: 'Chờ xác nhận', color: '#FF4D4F' },
    vip_customer: { name: 'Chờ xác nhận', color: '#1890FF' },
    outage_entire_area: { name: 'Chờ xác nhận', color: '#722ED1' },
    not_on_time: { name: 'Chờ xác nhận', color: '#13C2C2' },

    address_change: { name: 'Chờ xác nhận', color: '#FF9500' },
    completed_new_address_change: { name: 'Đã xác nhận', color: '#02D8A0' },
    power_company_request: { name: 'Điện lực chuyển yêu cầu', color: '#D1131D' },

    qa_integration_evaluating: { name: 'Đang đánh giá', color: '#1564E8' },
    qa_integration_waiting_confirm: { name: 'Chờ xác nhận', color: '#FF9500' },
    qa_integration_responded: { name: 'Đã phản hồi', color: '#AF52DE' },
    qa_integration_confirmed: { name: 'Đã xác nhận', color: '#02D8A0' },
    qa_integration_auto_confirmed: { name: 'Tự động xác nhận', color: '#02D8A0' }
  };

  return statusMap[status] || { name: 'Không xác định', color: 'gray' };
};

const RequestStatusBar: React.FC<RequestStatusBarProps> = ({ status = 'pending_reception' }) => {
  const statusInfo = getStatusInfo(status);

  return (
    <div
      style={{ background: statusInfo.color }}
      className={`request-status-bar mt-3 flex justify-between rounded-[5px] px-4 py-[11px]`}
    >
      <div>
        <Typography.Text className='text-[14px]/[18px] font-semibold text-[#FFFFFF]'>
          {requestform.detailStatusRequestForm}
        </Typography.Text>{' '}
        <Typography.Text className='text-[14px]/[18px] text-[#FFFFFF]'>{statusInfo.name}</Typography.Text>
      </div>
      <HourGlassStatusIcon />
    </div>
  );
};

export default RequestStatusBar;
